import * as Linking from "expo-linking";
import { useEffect, useRef } from "react";
import { addMinutes, differenceInSeconds, isAfter } from "date-fns";

import { Env } from "../env";
import { isPlatformWeb } from "./constants";

export function getExpiresIn(requestedAt: Date) {
  const maxDate = addMinutes(requestedAt, 10);
  const now = new Date();

  if (isAfter(now, maxDate)) {
    return 0;
  }

  // maxDate before now
  return differenceInSeconds(maxDate, now);
}

export function useInterval(callback: () => void, delay: number) {
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  });

  useEffect(() => {
    function tick() {
      callbackRef.current();
    }

    const id = setInterval(tick, delay);

    return () => clearInterval(id);
  }, [delay]);
}

export function url(pathname: string) {
  return `${Env.appUrl}/${pathname}`;
}

export function getDateFromServerTimestamp(timestamp: number) {
  return new Date(timestamp * 1000);
}

export function getServerTimestampFromDate(date: Date) {
  return Math.floor(date.getTime() / 1000);
}

export function isNumeric(value: string): boolean {
  return !isNaN(parseFloat(value));
}

export function ellipsis(txt: string, length: number) {
  if (txt.length <= length) {
    return txt;
  }

  return `${txt.substring(0, length)}...`;
}

export function openUrl(url: string) {
  if (isPlatformWeb) {
    window.open(url, "_blank");
  } else {
    Linking.openURL(url);
  }
}

export function openPath(pahtname: string) {
  openUrl(url(pahtname));
}

export function getTierName(tier: number | null) {
  if (tier === 1) {
    return "Silver";
  }

  if (tier === 2) {
    return "Gold";
  }

  if (tier === 3) {
    return "Platinum";
  }

  return null;
}
